export const SOCIAL_REFRESH_INTERVAL_MS = 60_000;

export function nextUtcWeekBoundary(now = Date.now()) {
  const current = new Date(now);
  const daysUntilMonday = ((8 - current.getUTCDay()) % 7) || 7;
  return Date.UTC(
    current.getUTCFullYear(),
    current.getUTCMonth(),
    current.getUTCDate() + daysUntilMonday,
  );
}

export function runtimeTickDelay({
  now,
  marketBoundary,
  guildBoundary,
  backgroundWakeAt,
  needsSecondTick,
  visible,
}) {
  const current = Number(now);
  if (!visible) {
    const wakeAt = Number(backgroundWakeAt);
    return Number.isFinite(wakeAt) && wakeAt > current
      ? Math.max(250, wakeAt - current + 50)
      : null;
  }
  const nextBoundary = Math.min(Number(marketBoundary), Number(guildBoundary));
  const untilBoundary = Math.max(250, nextBoundary - current + 50);
  return needsSecondTick ? Math.min(1000, untilBoundary) : untilBoundary;
}

export function shouldPollSocial({ visible, online, configured }) {
  return Boolean(visible && online && configured);
}
